ui-search-results-pagination {
  display: flex;
  justify-content: center;
  margin-top: $sd-spacing-8;

  .fetch-pagination {
    li {
      float: left;
      display: inline-block;
      position: relative;
      list-style-type: none;
      cursor: pointer;

      sd-button {
        &.active {
          &::part(base) {
            color: $sd-textColor-accent;
          }
        }

        &.more {
          &::part(base) {
            color: $sd-textColor-black;
          }
        }
      }
    }
  }
}
